import { createAction } from "@reduxjs/toolkit";

const addScenarioListAsyncAction = createAction("ADD_SCENARIO_LIST_ASYNC");

export const deleteScenarioTotalsAsyncAction = createAction(
  "DELETE_SCENARIO_TOTALS_ASYNC"
);

export const addScenarioTotalsAsyncAction = createAction(
  "ADD_SCENARIO_TOTALS_ASYNC"
);
export const changeSelectedScenarioAsyncAction = createAction(
  "CHANGE_SELECTED_SCENARIO_ASYNC"
);

export default addScenarioListAsyncAction;
